var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ERow',{staticClass:"ma-2",attrs:{"no-gutters":"","justify":"start","align":"start"}},[_c('div',{staticClass:"archive",on:{"click":_vm.initDownloadArchive}},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.dataType)+".zip")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"primary","small":""}},[_vm._v(" fa-solid fa-download ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }